import React from 'react';
import { Card } from 'antd';
import PropTypes from 'prop-types';
import './PartnerCard.scss';
import Button from 'ui-kit/Button';

const PartnerCard = ({ image, copy, onContinue }) => {
  return (
    <Card className="PartnerCard">
      <img src={image} alt="logo" className="PartnerCard_image" />
      <p>{copy}</p>
      <Button variant="contained" fullWidth onClick={onContinue}>
        Start now
      </Button>
    </Card>
  );
};

PartnerCard.propTypes = {
  image: PropTypes.any,
  copy: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default PartnerCard;
